/*
 * Modules
 */

import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/tab';
import './app/variables';
import './app/theme';
import './modules/videos-lazy-load';
import './modules/init-video-popups';
import './modules/scroll-to-hash-fix';
import './modules/nf-auto-scroll';
import './modules/nf-submit-response';
import './modules/nf-modal-scroll-fix';
import './modules/read-more';

// Cart Page
if ( $( '.woocommerce-cart' ).length ) {
	const $block = $( '.woocommerce-cart' );
	if ( $block.find( '.quantity' ).length ) {
		$block.find( '.quantity' ).each( function() {
			const $quantity = $( this );
			$quantity.prepend( '<button class="quantity-btn quantity-btn--decrease svg-icon js-decrease" aria-label="Decrease"></button>' );
			$quantity.append( '<button class="quantity-btn quantity-btn--increase svg-icon js-increase" aria-label="increase"></button>' );
			const $input = $quantity.find( 'input' );
			const $decrease = $quantity.find( '.js-decrease' );
			const $increase = $quantity.find( '.js-increase' );

			if ( parseInt( $input.val() ) <= 0 || !$input.val() || parseInt( $input.val() ) === 1 ) {
				$input.val( 1 );
				$decrease.addClass( 'disabled' );
			}

			$input.change( function() {
				if ( parseInt( $( this ).val() ) <= 0 || !$( this ).val() ) {
					$( this ).val( 1 );
					$decrease.addClass( 'disabled' );
				} else {
					$decrease.removeClass( 'disabled' );
				}
			} );

			$increase.on( 'click', function( e ) {
				e.preventDefault();
				$input.val( parseInt( $input.val() ) + 1 );
				$decrease.removeClass( 'disabled' );
			} );

			$decrease.on( 'click', function( e ) {
				e.preventDefault();
				if ( parseInt( $input.val() ) > 1 ) {
					$input.val( parseInt( $input.val() ) - 1 );

					if ( parseInt( $input.val() ) === 1 ) {
						$decrease.addClass( 'disabled' );
					}
				}
			} );
		} );
	}
}
